import React from "react";
import { getStockOrders, sendStockOrder } from "api/product";
import { toast } from "react-toastify";
import Loading from "components/loading";
import MainContext from "contexts/main";
import Orders from "./components/orders";
import Form from "./components/form";
import Dealer from "./components/dealer";
import Usage from "./components/usage";
import Confirm from "./components/confirm";
const StockPage = () => {
  const { user } = React.useContext(MainContext);
  const [state, dispatch] = React.useReducer(
    (state, action) => {
      switch (action.type) {
        case "SET_INIT_DATA":
          return {
            ...state,
            orders: action.payload,
            loading: false,
          };
        case "SET_STEP":
          return { ...state, step: action.payload };
        case "SET_SELECTED":
          let nextStep = "form";
          if (user?.profile.has_profile) {
            nextStep = "dealer";
          }
          return {
            ...state,
            selected: action.payload,
            selectedGeteway:
              action.payload.gateways.length === 1
                ? action.payload.gateways[0]
                : null,
            selectedUsage:
              action.payload.usages.length === 1
                ? action.payload.usages[0]
                : null,
            step: nextStep,
          };
        case "SET_SELECTED_DEALER":
          return { ...state, selectedDealer: action.payload };
        case "SET_SELECTED_USAGE":
          return { ...state, selectedUsage: action.payload };
        case "SET_SELECTED_GETEWAY":
          return { ...state, selectedGeteway: action.payload };
        default:
          return state;
      }
    },
    {
      orders: null,
      loading: true,
      step: "list",
      selected: null,
      selectedDealer: null,
      selectedGeteway: null,
      selectedUsage: null,
      recaptcha: null,
      submitingLoading: false,
    }
  );
  React.useLayoutEffect(() => {
    getStockOrders()
      .then((res) => {
        dispatch({ type: "SET_INIT_DATA", payload: res.data });
      })
      .catch((err) => {});
  }, []);
  const submit = async (captcha) => {
    dispatch({ type: "SUBMIT_LOADING", payload: true });
    const data = {};
    data.dealer_id = state.selectedDealer.id;
    data.gateway = state.selectedGeteway;
    data.usage=state.selectedUsage;
    sendStockOrder(state.selected.id, data)
      .then((res) => {
        dispatch({ type: "SUBMIT_LOADING", payload: false });
        window.location.replace(res.data.url);
      })
      .catch((err) => {
        dispatch({ type: "SUBMIT_LOADING", payload: false });
        if (err.response.status === 423) {
          toast.warning("سرور مشغول است دوباره تلاش کنید");
        }
      });
  };
  const stepView = () => {
    let data = state?.orders;
    switch (state.step) {
      case "form":
        return (
          <Form
            prev={() => dispatch({ type: "SET_STEP", payload: "list" })}
            nextStep={() => dispatch({ type: "SET_STEP", payload: "dealer" })}
          />
        );
      case "dealer":
        return (
          <Dealer
            selectedDealer={state.selectedDealer}
            setDealer={(dealer) =>
              dispatch({ type: "SET_SELECTED_DEALER", payload: dealer })
            }
            terms_of_sale_id={state.selected.terms_of_sale_id}
            prev={() => dispatch({ type: "SET_STEP", payload: "form" })}
            next={() => {
              if (state.selected.usages.length <= 1) {
                dispatch({ type: "SET_STEP", payload: "confirm" });
              } else {
                dispatch({ type: "SET_STEP", payload: "usage" });
              }
            }}
          />
        );
      case "usage":
        return (
          <Usage
            selectedUsage={state.selectedUsage}
            usages={state.selected.usages}
            setUsage={(id) =>
              dispatch({ type: "SET_SELECTED_USAGE", payload: id })
            }
            prev={() => dispatch({ type: "SET_STEP", payload: "dealer" })}
            next={() => dispatch({ type: "SET_STEP", payload: "confirm" })}
          />
        );
      case "confirm":
        return (
          <Confirm
            item={state.selected}
            selectedDealer={state.selectedDealer}
            recaptcha={state.recaptcha}
            submit={submit}
            loading={state.submitingLoading}
            goTo={(step) => dispatch({ type: "SET_STEP", payload: step })}
            prev={() => {
              if (state.selected.usages.length <= 1) {
                dispatch({ type: "SET_STEP", payload: "dealer" });
              } else {
                dispatch({ type: "SET_STEP", payload: "usage" });
              }
            }}
            selectedGeteway={state.selectedGeteway}
            setGeteway={(geteway) =>
              dispatch({ type: "SET_SELECTED_GETEWAY", payload: geteway })
            }
          />
        );
      default:
        return (
          <Orders
            orders={data}
            select={(item) => dispatch({ type: "SET_SELECTED", payload: item })}
          />
        );
    }
  };
  if (state.loading) {
    return <Loading />;
  }
  return stepView();
};
export default StockPage;
